import xss, { whiteList } from 'xss';

const newWhiteList = {};

// 把原本的默认白名单找出来，增加style标签，不然样式会有问题
Object.keys(whiteList).forEach(key => {
  const whiteItem = whiteList[key];
  whiteItem.push('style');
  newWhiteList[key] = whiteItem;
});

const RichTextXss = html => {
  const result = xss(html, {
    whiteList: newWhiteList,
    onTag: (tag, html) => {
      // 由于机器人中存在var标签 需要单独处理var标签的显示
      if (tag === 'var') {
        return html;
      }
    }
  });
  return result;
};

export default RichTextXss;
